import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface GuestIdentityModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (name: string, email: string) => void;
}

export function GuestIdentityModal({
    isOpen,
    onClose,
    onConfirm,
}: GuestIdentityModalProps) {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!name.trim() || !email.trim()) {
            setError("Please fill in all fields");
            return;
        }
        if (!email.includes("@")) {
            setError("Please enter a valid email address");
            return;
        }
        onConfirm(name, email);
    };

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-[425px] bg-white border-primary/20">
                <DialogHeader>
                    <DialogTitle className="text-primary font-bold text-2xl">Save to Wishlist</DialogTitle>
                    <DialogDescription className="text-gray-600">
                        Enter your details to save this tour to your wishlist. We'll use this to
                        keep track of your favorites.
                    </DialogDescription>
                </DialogHeader>
                <form onSubmit={handleSubmit}>
                    <div className="grid gap-4 py-4">
                        <div className="grid grid-cols-4 items-center gap-4">
                            <Label htmlFor="name" className="text-right text-primary font-medium">
                                Name
                            </Label>
                            <Input
                                id="name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                className="col-span-3 border-primary/20 focus-visible:ring-primary text-primary"
                                placeholder="John Doe"
                            />
                        </div>
                        <div className="grid grid-cols-4 items-center gap-4">
                            <Label htmlFor="email" className="text-right text-primary font-medium">
                                Email
                            </Label>
                            <Input
                                id="email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="col-span-3 border-primary/20 focus-visible:ring-primary text-primary"
                                placeholder="john@example.com"
                            />
                        </div>
                        {error && <p className="text-sm text-destructive text-right">{error}</p>}
                    </div>
                    <DialogFooter>
                        <Button type="submit" className="bg-primary text-white hover:bg-primary/90">Save to Wishlist</Button>
                    </DialogFooter>
                </form>
            </DialogContent>
        </Dialog>
    );
}
